import { useMutation } from '@tanstack/react-query';
import { profileApi } from '../api/profile.api';
import type { ChangePasswordRequest } from '../types/profile.types';

export function useChangePassword() {
  const mutation = useMutation({
    mutationFn: (data: ChangePasswordRequest) => profileApi.changePassword(data),
  });

  return {
    changePassword: mutation.mutateAsync,
    isSubmitting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
